import { connect } from 'react-redux';

import DataExportDialog from './DataExportDialog';
import {
  setIncludeDataset,
  setFileFormat,
  setExportSource,
  setTimeSource,
  setIncludeMetadata,
  setAgreedToTerms,
  handleDownloads,
  cancelDialog,
} from '../../actions/exportDialog';
import {
  getIncludeDataset,
  getFileFormat,
  getExportSource,
  getTimeSource,
  getIncludeMetadata,
  getDownloadsPending,
  isExportDisabled,
  getDownloadsFailed,
  getAgreedToTerms,
} from '../../selectors/exportDialog';
import { isCensusView } from '../../selectors/router';

export default connect(
  state => ({
    censusView: isCensusView(state),
    includeDataset: getIncludeDataset(state),
    fileFormat: getFileFormat(state),
    exportSource: getExportSource(state),
    timeSource: getTimeSource(state),
    includeMetadata: getIncludeMetadata(state),
    agreedToTerms: getAgreedToTerms(state),
    exportDisabled: isExportDisabled(state),
    downloadsPending: getDownloadsPending(state),
    downloadsFailed: getDownloadsFailed(state),
  }),
  {
    setIncludeDataset,
    setFileFormat,
    setExportSource,
    setTimeSource,
    setIncludeMetadata,
    setAgreedToTerms,
    handleDownloads,
    cancelDialog,
  },
)(DataExportDialog);



// WEBPACK FOOTER //
// ./src/components/DataExport/DataExportDialogContainer.jsx